import React, { useEffect, useMemo, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import UploadVideo from "./UploadVideo";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DoneIcon from "@mui/icons-material/Done";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    borderColor: "#ccc",
    boxShadow: "none",
    padding: "4px 8px",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: 160,
    overflowY: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 160, // scrolling height
    overflowY: "auto", // enable scroll
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: state.isFocused ? "#f0eaff" : "#fff",
    color: "#000",
    padding: "10px",
  }),
};

const AddVideo = () => {
  const naviagte = useNavigate();
  const location = useLocation();
  const { state } = location;
  const isEdit = state?.type === "edit";
  const videoData = state?.data;
  const video_prob_Data = {
    userType: videoData?.userType,
    category: videoData?.category,
    groupType: videoData?.groupType,
    language: videoData?.language,
    video: videoData?.video_data?.video,
    thumbnail: videoData?.video_data?.thumbnail_image,
    title: videoData?.video_data?.title,
    displayOn: videoData?.video_data?.display_on ?? [],
    displayFor: videoData?.video_data?.display_for ?? [],
  };
  const initial_empty_data = {
    userType: state?.userType ?? { label: "User", value: 1 },
    category: "",
    groupType: "",
    language: "",
    video: "",
    thumbnail: "",
    title: "",
    displayOn: [],
    displayFor: [],
  };
  const [data, setData] = useState(
    videoData ? video_prob_Data : initial_empty_data,
  );
  const [optionList, setOptionList] = useState({
    userType: [
      { label: "User", value: 1 },
      { label: "Hotels", value: 2 },
    ],
    category: [],
    languages: [],
    displayOn: ["Dashboard", "Support Section", "FAQ"],
    displayFor: ["Owner", "Receptionist"],
  });
  const [errors, setErrors] = useState(false);
  const thumpRef = useRef(null);

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCheckBoxChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: [
        ...(prev?.[name]?.includes(value)
          ? prev?.[name]?.filter((item) => item !== value)
          : [...prev?.[name], value]),
      ],
    }));
  };

  const optionsFilter = (list, id) => {
    let filtered = list?.filter((item) => item?.type === id);
    return filtered ?? [];
  };

  //api functions

  const getLanguages = async () => {
    let res = await get(`${URLS.LANGUAGE_LIST}?type=1`);
    if (res?.status === "success") {
      setOptionList((prev) => ({
        ...prev,
        languages: res?.data
          ?.filter((item) => item?.status)
          ?.map((item) => ({ ...item, value: item?.id, label: item?.name })),
      }));
    }
  };

  const getCategories = async () => {
    let res = [];
    let UserRes = await get(`${URLS.VIDEO_CATEGORY_LIST}?type=1`);
    if (UserRes?.status === "success") {
      res = UserRes?.data?.filter((item) => item?.status);
    }
    let hotelRes = await get(`${URLS.VIDEO_CATEGORY_LIST}?type=2`);
    if (hotelRes?.status === "success") {
      res = [...res, ...hotelRes?.data?.filter((item) => item?.status)];
    }
    let modified = res?.map((item) => ({
      ...item,
      label: item?.name,
      value: item?.id,
      groups: item?.groups?.map((group) => ({
        ...group,
        label: group?.name,
        value: group?.id,
      })),
    }));
    let findedCategory = state?.userType
      ? modified?.find((item) => item?.type === state?.userType?.value)
      : modified?.[0];
    if (findedCategory && !videoData?.userType) {
      handleChange("userType", {
        label: findedCategory?.type === 1 ? "User" : "Hotels",
        value: findedCategory?.type,
      });
      handleChange("category", findedCategory);
    }
    setOptionList((prev) => ({
      ...prev,
      category: modified,
    }));
  };

  useEffect(() => {
    sessionStorage.setItem("tutorial_videos_active_tab", "3");
    getLanguages();
    getCategories();
  }, []);

  const Submit = async () => {
    let error = false;
    Object.values(data).forEach((val) => {
      if (!val) error = true;
    });
    if (
      error ||
      (data?.userType?.value === 2 &&
        (data.displayFor?.length == 0 || data.displayOn?.length == 0))
    ) {
      setErrors(true);
      return;
    }
    let {
      category,
      displayFor,
      displayOn,
      groupType,
      language,
      thumbnail,
      title,
      userType,
      video,
    } = data;

    const formData = new FormData();

    formData.append("title", title);
    formData.append("category", category?.id);
    formData.append("group", groupType?.id);
    formData.append("language", language?.id);
    formData.append("type", userType?.value);

    displayFor.forEach((item) => {
      formData.append("display_for", item);
    });

    displayOn.forEach((item) => {
      formData.append("display_on", item);
    });

    if (typeof data?.thumbnail !== "string")
      formData.append("image", thumbnail);
    if (typeof data?.video !== "string") formData.append("video_file", video);
    let url = isEdit
      ? `${URLS.VIDEO_EDIT}${videoData?.video_data?.id}/`
      : URLS.VIDEO_CREATE;
    let method = isEdit ? put : post;
    let res = await method(url, formData);
    console.log("onsubmit", data, res);
    if (res?.status === "success") {
      toast.success(res?.message);
      naviagte(-1);
    }
  };

  return (
    <div>
      <Topbar header={"Tutorial Videos"} back={true} />
      <hr className="mt-1 mb-1" style={{ backgroundColor: "#D1D1D6" }}></hr>

      {/* dropdown  */}
      <div className="row mt-3">
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            User Type <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={optionList.userType}
            value={data?.userType}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                userType: e,
                category: optionsFilter(optionList?.category, e?.value)?.[0],
              }));
            }}
            isDisabled={isEdit}
            placeholder="Select User Type"
            styles={customStyles}
          />
          {errors && !data?.userType && <p className="err">Select User Type</p>}
        </div>
        <div className="col-md-6 mb-3">
          <label className="fw-semibold mb-1">
            Category <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            options={
              optionsFilter(optionList?.category, data?.userType?.value) ?? []
            }
            value={data?.category}
            onChange={(e) => {
              setData((prev) => ({
                ...prev,
                userType: prev.userType,
                category: e,
                groupType: "",
              }));
            }}
            isDisabled={isEdit}
            placeholder="Select Category"
            styles={customStyles}
          />
          {errors && !data?.category && <p className="err">Select Category</p>}
        </div>
      </div>

      {/* group name  */}
      <div className="row mt-3">
        <label className="fw-semibold mb-1">
          Group Type <span style={{ color: "red" }}>*</span>
        </label>
        <div className="d-flex ac-jb py-3">
          <div className="d-flex gap-3">
            {(data?.category?.groups ?? [])?.map((ele) => {
              return (
                <div
                  key={ele?.id}
                  style={{
                    background:
                      data?.groupType?.id == ele?.id ? "#AE55F5" : "#78788029",
                    padding: "10px 30px",
                    borderRadius: 7,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleChange("groupType", ele);
                  }}
                >
                  <p
                    className="f1  text-center fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                    style={{
                      color:
                        data?.groupType?.id == ele?.id ? "#fff" : "#6B7280",
                    }}
                  >
                    {ele?.name} - {ele?.language_count}/
                    {optionList.languages?.length}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        {errors && !data?.groupType && <p className="err">Select Group Type</p>}
      </div>

      {/* languages  */}
      {isEdit ? (
        <div className="row mt-3">
          <div className="col-md-6 mb-3">
            <label className="fw-semibold mb-1">
              Language <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={optionList.languages}
              value={data?.language}
              onChange={(e) => {
                handleChange("language", e);
              }}
              placeholder="Select Language"
              styles={customStyles}
            />
            {errors && !data?.language && (
              <p className="err mt-1">Select Language</p>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex  ac-js mt-3 gap-2 pv-3 overflow-auto">
            {optionList.languages?.map((lan) => {
              return (
                <div className="px-3 border-right-gray pointer">
                  <div
                    onClick={() => {
                      handleChange("language", lan);
                    }}
                    className={`${data?.language?.id === lan?.id ? "border-bottom-line" : ""}  px-3 py-2`}
                  >
                    <p
                      className="text-center fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 "
                      style={{
                        color:
                          data?.language?.id === lan?.id
                            ? "#AE55F5"
                            : "#6B7280",
                      }}
                    >
                      {lan?.name}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          {errors && !data?.language && (
            <p className="err mt-1">Select Language</p>
          )}
        </>
      )}

      {/* video section  */}
      <div className="col-12 d-flex as-jb mt-5">
        {/* video upload section */}
        <div className="col-6">
          <div className="col-10">
            <label className="fw-semibold mb-1">Upload Video</label>
            {errors && !data?.video && <p className="err mt-1">Upload Video</p>}
            <UploadVideo
              video={data?.video}
              setVideo={(e) => handleChange("video", e)}
            />

            <label className="fw-semibold  mt-3">Tutorial Videos</label>
            <p className="text-danger mt-1">Max Upload Size : 75MB</p>
            <p className="text-danger  mt-1">
              Max Duration : <span className="black">2:00 mins</span>*
            </p>
          </div>
        </div>
        {/* video details section  */}
        <div className="col-6">
          <div className="col-11">
            {/* thumbnail  */}
            <div className=" mb-3 col-12">
              <label className="fw-semibold mb-1">Thumbnail Image</label>
              <div className="form-controls d-flex ac-jb">
                <p className="">
                  {data?.thumbnail?.name ?? data?.thumbnail?.split("/")?.at(-1)}
                </p>
                <input
                  name="userName"
                  ref={thumpRef}
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleChange("thumbnail", e.target.files[0])}
                  style={{ display: "none" }}
                  placeholder="Enter Receptionist Name"
                />
                <div
                  onClick={() => thumpRef.current.click()}
                  class="pointer video-left-line ps-2"
                >
                  <FileUploadOutlinedIcon
                    htmlColor="#3C3C4399"
                    fontSize="small"
                  />
                </div>
              </div>
              {errors && !data?.thumbnail && (
                <p className="err mt-1">Upload Thumbnail</p>
              )}
            </div>
            {/* video title  */}
            <div className=" mb-3 col-12">
              <label className="fw-semibold mb-1">Video Title</label>
              <input
                value={data?.title}
                className="form-controls"
                placeholder="Video Title"
                onChange={(e) => handleChange("title", e.target.value)}
              />

              {errors && !data?.title && (
                <p className="err mt-1">Enter Title</p>
              )}
            </div>
            {/* display on  */}
            {data?.userType?.value === 2 && (
              <div className="mb-3 col-12">
                <div className="d-flex ac-jb">
                  <label className="fw-semibold mb-1">Display on</label>

                  <div className="d-flex ac-jc">
                    <div
                      onClick={() => {
                        handleChange(
                          "displayOn",
                          data?.displayOn?.length ===
                            optionList?.displayOn?.length
                            ? []
                            : optionList?.displayOn,
                        );
                      }}
                      style={{
                        backgroundColor:
                          data?.displayOn?.length ===
                          optionList?.displayOn?.length
                            ? "#58CC02"
                            : "#fff",
                        borderColor:
                          data?.displayOn?.length ===
                          optionList?.displayOn?.length
                            ? "#58CC02"
                            : undefined,
                      }}
                      className={`check-box-btn d-flex ac-jc`}
                    >
                      {data?.displayOn?.length ===
                        optionList?.displayOn?.length && (
                        <DoneIcon
                          htmlColor="#fff"
                          style={{ height: "15px", width: "15px" }}
                          fontSize="small"
                        />
                      )}
                    </div>
                    <p className="f2 ms-2">Select All</p>
                  </div>
                </div>

                {errors && data?.displayOn?.length === 0 && (
                  <p className="err mt-1">Select Display On</p>
                )}
                <div className="row g-2 mt-2">
                  {optionList?.displayOn?.map((item, ind) => {
                    return (
                      <div key={ind} className={"col-6"}>
                        <div className="border p-2 rounded-2 d-flex ac-jb">
                          <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 ">
                            {item}
                          </p>
                          <div
                            onClick={() =>
                              handleCheckBoxChange("displayOn", item)
                            }
                            style={{
                              backgroundColor: data?.displayOn?.includes(item)
                                ? "#58CC02"
                                : "#fff",
                              borderColor: data?.displayOn?.includes(item)
                                ? "#58CC02"
                                : undefined,
                            }}
                            className={`check-box-btn d-flex ac-jc`}
                          >
                            {data?.displayOn?.includes(item) && (
                              <DoneIcon
                                htmlColor="#fff"
                                style={{ height: "15px", width: "15px" }}
                                fontSize="small"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {/* display For  */}
            {data?.userType?.value === 2 && (
              <div className="mb-3 col-12">
                <div className="d-flex ac-jb">
                  <label className="fw-semibold mb-1">Display For</label>

                  <div className="d-flex ac-jc">
                    <div
                      onClick={() =>
                        handleChange(
                          "displayFor",
                          data?.displayFor?.length ===
                            optionList?.displayFor?.length
                            ? []
                            : optionList?.displayFor,
                        )
                      }
                      style={{
                        backgroundColor:
                          data?.displayFor?.length ===
                          optionList?.displayFor?.length
                            ? "#58CC02"
                            : "#fff",
                        borderColor:
                          data?.displayFor?.length ===
                          optionList?.displayFor?.length
                            ? "#58CC02"
                            : undefined,
                      }}
                      className={`check-box-btn d-flex ac-jc`}
                    >
                      {data?.displayFor?.length ===
                        optionList?.displayFor?.length && (
                        <DoneIcon
                          htmlColor="#fff"
                          style={{ height: "15px", width: "15px" }}
                          fontSize="small"
                        />
                      )}
                    </div>
                    <p className="f2 ms-2">Select All</p>
                  </div>
                </div>
                {errors && data?.displayFor?.length === 0 && (
                  <p className="err mt-1">Select Display For</p>
                )}
                <div className="row g-2 mt-2">
                  {optionList?.displayFor?.map((item, ind) => {
                    return (
                      <div key={ind} className={"col-6"}>
                        <div className="border p-2 rounded-2 d-flex ac-jb">
                          <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 ">
                            {item}
                          </p>
                          <div
                            onClick={() =>
                              handleCheckBoxChange("displayFor", item)
                            }
                            style={{
                              backgroundColor: data?.displayFor?.includes(item)
                                ? "#58CC02"
                                : "#fff",
                              borderColor: data?.displayFor?.includes(item)
                                ? "#58CC02"
                                : undefined,
                            }}
                            className={`check-box-btn d-flex ac-jc`}
                          >
                            {data?.displayFor?.includes(item) && (
                              <DoneIcon
                                htmlColor="#fff"
                                style={{ height: "15px", width: "15px" }}
                                fontSize="small"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* submit buttons  */}
            <div className="d-flex gap-2">
              <button
                onClick={() => {
                  naviagte(-1);
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 video-submit-btn "
              >
                cancel
              </button>{" "}
              <button
                onClick={Submit}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 border-0 white bg-primary1 video-submit-btn"
              >
                {isEdit ? "Edit" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVideo;
